import { ButtonLink } from '@getslot/ui-web/button'
import { CheckIcon, ClockIcon, LockIcon, TelegramIcon } from '@getslot/ui-web/icons'
import { LiveDot } from '@getslot/ui-web/status'
import { Wordmark } from '@getslot/ui-web/wordmark'
import { cx } from '@getslot/ui-web/cx'
import { MINI_APP_URL } from '../../shared/config'
import styles from './welcome-page.module.css'

const POINTS = [
  { icon: <ClockIcon />, tone: styles.tileBlue, text: 'Следим за календарём круглосуточно' },
  { icon: <CheckIcon />, tone: styles.tilePeach, text: 'Записываем сами и присылаем скриншот' },
  { icon: <LockIcon />, tone: styles.tileGreen, text: 'Пароль удаляем через сутки после записи' },
]

/** Экран входа (макет «1 · Вход»): вне Telegram ведёт в Mini App бота. */
export function WelcomePage() {
  return (
    <div className={styles.page}>
      <div className={styles.top}>
        <Wordmark />
        <div aria-hidden="true" className={styles.radar}>
          <span className={styles.ring} />
          <span className={styles.ring} />
          <span className={styles.ring} />
          <span className={styles.core} />
        </div>
        <h1 className={styles.title}>
          Запишем
          <br />
          на визу в США,
          <br />
          пока вы
          <br />
          живёте жизнь
        </h1>
        <span className={styles.chip}>
          <LiveDot tone="live" />
          Следим за датами в Астане
        </span>
      </div>
      <div className={styles.sheet}>
        <ul className={styles.points}>
          {POINTS.map((point) => (
            <li key={point.text} className={styles.point}>
              <span className={cx(styles.tile, point.tone)}>{point.icon}</span>
              {point.text}
            </li>
          ))}
        </ul>
        <ButtonLink variant="ink" href={MINI_APP_URL} rel="noopener">
          <TelegramIcon />
          Войти через Telegram
        </ButtonLink>
        <p className={styles.hint}>Без паролей и SMS. Откроется GetSlot в Telegram.</p>
      </div>
    </div>
  )
}
